/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faBell } from '@fortawesome/free-regular-svg-icons';
import LoadingBar from '../../../../Components/LoadingBar/LoadingBar';
import Module from './Module';
import DataPanel from '../../../../Components/DataPanel/DataPanel';
import XpektorButton from '../../../../Components/XpektorButton/XpektorButton';
import { TranslateTriggers } from '../../../../Components/Utilities/TriggerTexts/DefaultTriggers';
import GraphPreviewImage from '../../../../Images/graphPreviewImage.png';

const gT = (t, key) => t(`company-info-modules.liquidity${key}`);
const gsT = (t, key) => t(`shared${key}`);

export default function Liquidity({
  liquidityStatus,
  onPdfClick,
  onHistoryClick,
  onTriggerClick,
  t,
}) {
  const [translatedTriggers, setTranslatedTriggers] = useState([]);

  useEffect(() => {
    if (liquidityStatus !== null && Object.keys(liquidityStatus).length > 0) {
      setTranslatedTriggers(TranslateTriggers(liquidityStatus.triggers));
    }
  }, [liquidityStatus]);

  return (
    <Module>
      {!liquidityStatus ? (
        <p className="module-empty-text">{gT(t, '.module-empty-text')}</p>
      ) : !liquidityStatus?.liquidityReport ? (
        <LoadingBar active status={gT(t, '.loading-bar')} relative />
      ) : (
        <>
          <Module.Nav>
            <div />
            <div style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
              <XpektorButton
                icon={faDownload}
                content={gT(t, '.xpektor-btn.save-as-pdf')}
                onClick={() =>
                  onPdfClick(() =>
                    document.getElementById('liquidity-pdf-wrapper')
                  )
                }
              />
            </div>
          </Module.Nav>
          <div id="liquidity-pdf-wrapper">
            <Module.KeyFigureSection>
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.bank-balance')}
                value={liquidityStatus.liquidityReport.bankBalance}
                valueType="currency"
                info={gT(t, '.key-figure.info.bank-balance')}
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.upcoming-incoming-payments')}
                value={liquidityStatus.liquidityReport.upcomingIncomingPayments}
                valueType="currency"
                info={gT(t, '.key-figure.info.upcoming-incoming-payments')}
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.upcoming-outgoing-payments')}
                value={liquidityStatus.liquidityReport.upcomingOutgoingPayments}
                valueType="currency"
                info={gT(t, '.key-figure.info.upcoming-outgoing-payments')}
              />
              <Module.KeyFigure
                title={gT(t, '.key-figure.title.predictive-cash-flow')}
                value={liquidityStatus.liquidityReport.predictiveCashFlow}
                valueType="currency"
                info={gT(t, '.key-figure.info.predictive-cash-flow')}
              />
            </Module.KeyFigureSection>
            <Module.DataSection>
              <Module.DataColumn>
                <DataPanel title={gT(t, '.data-panel.title.history')}>
                  <img src={GraphPreviewImage} alt="graph-preview" />
                  <DataPanel.Button
                    text={gT(t, '.data-panel.btn.history')}
                    onClick={onHistoryClick}
                  />
                </DataPanel>
                <DataPanel
                  title={gT(t, '.data-panel.title.to-keep-in-mind')}
                  icon={faBell}
                  scroll
                  maxHeight={400}
                >
                  {translatedTriggers.map((data) => (
                    <DataPanel.TriggerEntry
                      text={data.texts.name}
                      onClick={() => onTriggerClick(data.texts)}
                      key={`${data.id} liquidity`}
                    />
                  ))}
                </DataPanel>
              </Module.DataColumn>
              <Module.DataColumn>
                <DataPanel title={gT(t, '.data-panel.title.taxes')}>
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.tax-balance')}
                    value={liquidityStatus.liquidityReport.taxBalance}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.tax-balance')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.vat-to-pay')}
                    value={liquidityStatus.liquidityReport.vatToPay}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.vat-to-pay')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.tax-to-pay')}
                    value={liquidityStatus.liquidityReport.taxToPay}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.tax-to-pay')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.deferment')}
                    value={liquidityStatus.liquidityReport.deferment ?? 0}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.deferment')}
                  />
                </DataPanel>
                <DataPanel title={gT(t, '.data-panel.title.other')}>
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.ostli')}
                    value={liquidityStatus.liquidityReport.ostli}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.ostli')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.prospective-salary')}
                    value={
                      liquidityStatus.liquidityReport.prospectiveSalaryThisMonth
                    }
                    valueType="currency"
                    info={gT(t, '.value-entry.info.prospective-salary')}
                  />
                </DataPanel>
                <DataPanel title={gT(t, '.data-panel.title.ability-to-pay')}>
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.average-payment-customer')}
                    value={
                      liquidityStatus.liquidityReport.averagePaymentCustomers ??
                      gsT(t, '.labels.not-available')
                    }
                    valueType={
                      liquidityStatus.liquidityReport
                        .averagePaymentCustomers !== null
                        ? 'dgr över'
                        : ''
                    }
                    info={gT(t, '.value-entry.info.average-payment-customer')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.amount-late-tax-payments')}
                    value={gsT(t, '.labels.not-available')}
                    valueType=""
                    info={gT(t, '.value-entry.info.amount-late-tax-payments')}
                  />
                </DataPanel>
              </Module.DataColumn>
              <Module.DataColumn>
                <DataPanel title={gT(t, '.data-panel.title.reminder-fees')}>
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.earning-interest')}
                    value={liquidityStatus.liquidityReport.earningInterest}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.earning-interest')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.cost-interest')}
                    value={liquidityStatus.liquidityReport.costInterest}
                    valueType="currency"
                    info={gT(t, '.value-entry.info.cost-interest')}
                  />
                  <DataPanel.ValueEntry
                    label={gT(t, '.value-entry.label.sum')}
                    value={
                      liquidityStatus.liquidityReport.costAndEarningInterestSum
                    }
                    valueType="currency"
                  />
                </DataPanel>
                <DataPanel title={gT(t, '.data-panel.title.information')}>
                  {liquidityStatus.triggers.includes(46) && (
                    <>
                      <DataPanel.Subtitle
                        title={gT(t, '.subtitle.company-handles-cash')}
                      />
                      <DataPanel.ValueEntry
                        label={gT(t, '.value-entry.label.cash')}
                        value={liquidityStatus.liquidityReport.cash}
                        valueType="currency"
                      />
                    </>
                  )}
                  {liquidityStatus.triggers.includes(47) && (
                    <>
                      <DataPanel.Subtitle
                        title={gT(t, '.subtitle.feared-bad-debt')}
                      />
                      <DataPanel.ValueEntry
                        label={gT(t, '.value-entry.label.feared-bad-debt')}
                        value={liquidityStatus.liquidityReport.fearedBadDebt}
                        valueType="currency"
                      />
                    </>
                  )}
                </DataPanel>
              </Module.DataColumn>
            </Module.DataSection>
          </div>
        </>
      )}
    </Module>
  );
}
